import './skill.css';

export function Skill({image, title, backgroundColor} : any) {
    return (
        <div className="skill-wrapper">
            <div className="skill-image-wrapper" style={{backgroundColor: backgroundColor}}><img className="skill-image" src={image} /></div>
            <p className="skill-title">{ title }</p>
        </div>
    )
}